import ApiUrlConstants from '@/common/ApiUrlConstants'
import CommonUtil from '@/common/utils/CommonUtil'

export default class JISTWEBSSORDRCTService {
  /**
   * CAAA1016API処理呼出
   * @param specCode
   * @param compCode
   * @param reasonCode
   * @param juns
   * @param just
   */
  public async callAPICAAA1016(
    specCode: string,
    compCode: string,
    reasonCode: string,
    juns: string,
    just: string,
    xsrfToken: string
  ) {
    const dataForm = [
      { name: 'SPECCODE', value: specCode },
      { name: 'COMPCODE', value: compCode },
      { name: 'REASONCODE', value: reasonCode },
      { name: 'JUNS', value: juns },
      { name: 'JUST', value: just },
      { name: 'ACC-KEY', value: CommonUtil.createApiCallControlAccessKey() },
      { name: '_csrf', value: xsrfToken }
    ]

    const form: HTMLFormElement = CommonUtil.createForm(
      'POST',
      process.env.VUE_APP_BASE_API + ApiUrlConstants.CAAA1016,
      '_self',
      dataForm
    )
    document.body.appendChild(form)
    form.submit()
  }
}
